import { Component, Input, Output, OnChanges, EventEmitter } from "@angular/core";
import { VNavBarService } from "@directives/_core/v-nav-bar/v-nav-bar.service.ts";
import './v-nav-item.component.scss';

@Component({
    selector: 'v-nav-item',
    template: require('./v-nav-item.component.html')
})
export class VNavItemComponent implements OnChanges {
    @Input() label: string;
    @Input() selected: boolean;

    constructor(
        private readonly navBarService: VNavBarService) { }

    ngOnChanges(): void {
    }

    itemClick() {
        this.navBarService.navItemChange(this);
    }

}
